import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community'
import { AllEnterpriseModule } from 'ag-grid-enterprise'

import GuDatagridClient from './components/GuDatagridClient.vue'
import GuDatagridServer from './components/GuDatagridServer.vue'

import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-quartz.css'

ModuleRegistry.registerModules([
  AllCommunityModule,
  AllEnterpriseModule,
])

provideGlobalGridOptions({ theme: 'legacy' })

export { GuDatagridClient, GuDatagridServer }
